import React from 'react';

const SuperCropTwo: React.FunctionComponent = (props) => (
    <svg
        width="75px"
        height="80px"
        viewBox="0 0 80 80"
        data-testid="ttd-super-crop-two"
        {...props}
    >
        <defs>
            <circle id="supercrop2-path-1" cx="40" cy="40" r="40" />
        </defs>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g>
                <mask id="supercrop2-mask-2" fill="white">
                    <use xlinkHref="#supercrop2-path-1" />
                </mask>
                <path
                    d="M-10,62.6675841 C15.4962089,21.097528 36.1750909,0.3125 52.0366458,0.3125 C75.8289781,0.3125 78.2779203,20.6457262 72.1319348,39.0749558 C65.9859492,57.5041854 59.1407262,71.0196681 57.3255016,80.3125 C57.3255016,80.3125 49.0503344,80.3125 32.5,80.3125 C35.642018,68.336358 40.7829689,55.7226932 47.9228526,42.4715057 C58.6326781,22.5947244 50.412723,7.82562547 32.5,35.3066069 C20.5581847,53.6272612 11.0967809,68.6292256 4.11578854,80.3125 L-10,80.3125 L-10,62.6675841 Z"
                    fill="#000000"
                    mask="url(#supercrop2-mask-2)"
                />
            </g>
        </g>
    </svg>
);

export default SuperCropTwo;
